import Animated from 'react-native-reanimated';
import { ForwardedRef, forwardRef } from 'react';
import { ScrollView as RNScrollView } from 'react-native';
import { ScrollViewProps } from './ScrollView.types';
import useStyle from '../../hooks/useStyle';

function ScrollView(
  { contentContainerStyle = {}, animated = false, ...rest }: ScrollViewProps,
  ref: ForwardedRef<RNScrollView | Animated.ScrollView>,
) {
  const ScrollViewComponent = animated ? Animated.ScrollView : RNScrollView;
  const style = useStyle(contentContainerStyle);

  return (
    <ScrollViewComponent ref={ref} contentContainerStyle={style} {...rest} />
  );
}

export default forwardRef(ScrollView);
